import { SYSTEM_CONSTANT } from '~/constants/system-constant'

// Backend trả path dạng root-relative ("/uploads/..."), khác domain với admin-react — nối domain
// identity-service vào thì <img src> mới load được, không thì trình duyệt tự resolve nhầm domain và vỡ ảnh.
export const resolveIdentityAssetUrl = (path?: string | null): string | undefined =>
  (path ? `${SYSTEM_CONSTANT.IDENTITY_SERVER_URL}${path}` : undefined)
